//updated with v20.12.2

import { applyMiddleware, compose, createStore } from "redux";
import { persistReducer, persistStore } from 'redux-persist';

import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import storage from 'redux-persist/lib/storage';

const persistConfig: any = {
  key: 'root',
  storage,
  blacklist: [
    'loginReducer',
    'viewStateReducer'
  ],
  debug: true,
};

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers:any = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

const enhancers = [applyMiddleware(...middleware)];

const persistedReducer = persistReducer(persistConfig, rootReducer);

const configureStore = () => {
  const store = createStore(persistedReducer, undefined, composeEnhancers(...enhancers));
  const persister = persistStore(store, null, () => {
  });

  sagaMiddleware.run(rootSaga);
  return { persister, store };
};

export default configureStore;